import React from 'react';

import AddIcon from '@atlaskit/icon/glyph/add';
import EditorHorizontalRuleIcon from '@atlaskit/icon/glyph/editor/horizontal-rule';
import EditorMoreIcon from '@atlaskit/icon/glyph/editor/more';
import EditorSuccessIcon from '@atlaskit/icon/glyph/editor/success';
import ErrorIconBase from '@atlaskit/icon/glyph/error';
import Spinner from '@atlaskit/spinner';

import { JIRA_ICON, PD_ICON } from 'src/lib/featureFlags';

export const PdIcon = () => <img src={PD_ICON} alt="pd" style={{ width: '1rem', maxHeight: '1rem', marginRight: '2px', marginLeft: '2px' }}/>;
export const JiraIcon = () => <img src={JIRA_ICON} alt="pd" style={{ width: '1rem', maxHeight: '1rem', marginRight: '2px', marginLeft: '2px' }}/>;
export const CreateIcon = () => <AddIcon primaryColor="#00875A" />;
export const DeleteIcon = () => <EditorHorizontalRuleIcon primaryColor="#DE350B" />;
export const WaitIcon = () => <EditorMoreIcon/>;
export const LoadingIcon = () => (
  <span style={{ display: 'inline-block', width: 'inherit', textAlign: 'center' }}>
    <Spinner size="small" />
  </span>
);
export const ErrorIcon = () => <ErrorIconBase primaryColor="#DE350B" />;
export const DoneIcon = () => <EditorSuccessIcon primaryColor="#00875A" />;
